export default __webpack_public_path__ + "static/media/payment_card.b76a49fe.svg";